var _line, _line2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneFly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 20,
    viewBox: "0 0 132 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 9.5,
    x2: 49,
    y2: 9.5,
    stroke: "black",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 9.5,
    x2: 132,
    y2: 9.5,
    stroke: "black",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 6.5H60.5L62 8.5L67.5 8.5L65 0L67 0L72 8.5L77.5 8.5C77.9167 8.5 78.2708 8.64583 78.5625 8.9375C78.8542 9.22917 79 9.58333 79 10C79 10.4167 78.8542 10.7708 78.5625 11.0625C78.2708 11.3542 77.9167 11.5 77.5 11.5L72 11.5L67 20H65L67.5 11.5L62 11.5L60.5 13.5H59L60 10L59 6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneFly);
export default __webpack_public_path__ + "static/media/planeFly.6cbd77ba228c62291cbb7eeab69b35d1.svg";
export { ForwardRef as ReactComponent };